module.exports = __webpack_public_path__ + "media/images/hrms/facebook-circle-5364c64b2bbe666edcf25200f447a9e9.png";